document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const openButtons = document.querySelectorAll('[data-custom-swatch-modal-open]');
  const modalContainers = document.querySelectorAll('.custom-swatch-modal');

  if (modalContainers.length) {
    modalContainers.forEach((container) => {
      const collectionHandle = container.getAttribute('data-custom-swatch-collection');
      const maxProducts = container.getAttribute('data-custom-swatch-max');
      const label = container.getAttribute('data-custom-swatch-label');
      console.log('[Swatch Nav] Rendered', {
        collectionHandle,
        maxProducts,
        label,
      });
    });
  } else {
    console.log('[Swatch Nav] Not rendered on this page');
  }

  if (!openButtons.length) return;

  const closeModal = (modal) => {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    body.classList.remove('custom-swatch-modal__body--locked');
  };

  const loadModalImages = (modal) => {
    const images = modal.querySelectorAll('.custom-swatch-modal__img[data-src]');
    images.forEach((img) => {
      const src = img.getAttribute('data-src');
      if (!src) return;
      img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      img.src = src;
      if (img.complete) img.classList.add('is-loaded');
    });
  };

  const openModal = (modal) => {
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    body.classList.add('custom-swatch-modal__body--locked');
    loadModalImages(modal);
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-custom-swatch-modal-target');
      const modal = targetId ? document.getElementById(targetId) : null;
      if (modal) openModal(modal);
    });
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-custom-swatch-modal-close]');
    const modal = event.target.closest('[data-custom-swatch-modal]');

    if (closeButton && modal) {
      closeModal(modal);
      return;
    }

    if (modal && event.target === modal) {
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-custom-swatch-modal].is-active').forEach(closeModal);
  });
});
